module.exports = __webpack_public_path__ + "static/02_mobile-10052a020123053f2fd2c03bcbfd09f3.png";